import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, RouterLink } from '@angular/router';
import { switchMap, finalize } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { GenericLambdaReturn } from '../models/genericLamba';
import { SeverityViewService, SeverityType, AcknowledgeDetailType, SeverityLambdaReturn   } from '../services/severity-view.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { DetailsTable } from './details-table.component'
import {AcknowledgeTable} from './acknowledge-table.component'
import { Router } from '@angular/router';
import { LocationInformationService } from '../services/location-information.service';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { saveAs } from 'file-saver';
import { LoadingService } from '../services/loading.service';
import { DateSelectionComponent } from '../date-selection/date-selection.component';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
    selector: 'app-severity-view',
    templateUrl: './severity-view.component.html',
    styleUrls: ['./severity-view.component.scss'],
    imports: [RouterLink, DateSelectionComponent, MatButton, MatFormField, MatInput, ReactiveFormsModule, FormsModule, MatSelect, MatOption, NgFor, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, NgIf, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DatePipe]
})
export class SeverityViewComponent implements OnInit, OnDestroy {
  dataSource: MatTableDataSource<SeverityType>
  @ViewChild(MatSort, { static: false }) set content(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  mDataSource: SeverityType[]
  subscription: Subscription;
  detailsSubscription: Subscription;
  currentShift: string = "True";  
  dateString: string;
  public fromDateString: string;
  public toDateString: string;
  private location: string;
  public plant: string;
  public plantDisplay: string;
  public line: string;
  public lineDisplay: string;
  public severity: string;
  severityDetailsArr: any[];
  severityInfo:string;
  dataSourceName = 'Severity Details';
  downloadSubscription: Subscription;

  filterValues = {
    model: '',
    serial: '',
    area: '',
    component: '',
    defect: '',
    severity: '',
    shift: '',
    line: ''
  };

  filteredData: SeverityType[] = [];
  uniqueAreas: string[] = [];
  uniqueComponents: string[] = [];
  uniqueDefects: string[] = [];
  uniqueShifts: string[] = [];

  fg_hdr: FormGroup;
  manualInput: boolean = false;
  pageSize = 2000;
  currentOffset = 0;
  hasMore = false;
  isLoading = false;
  currentPage = 1;
  isFilterApplied: boolean = false;
  currentDownloadOffset = 0;
  isDownloading = false;
  allRecords: SeverityType[] = [];
  totalRecords = 0;


  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['ResultDateTime', 'Shift', 'Line',  'Model', 'Serial', 'AuditType','Severity', 'Acknowledge','AreaDescription', 'ComponentDescription', 'DefectDescription',  'OperatorName', 'Notes', 'Details'];
  isTablet$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])
  isScreen$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])

  constructor(private service: SeverityViewService,
              private loadingService: LoadingService,
              private breakpointObserver: BreakpointObserver, 
              private locationInformationService: LocationInformationService, 
              private route: ActivatedRoute,
              private router: Router,
              private detailsDialog: MatDialog,
              private AcknowledgeDialog:MatDialog,
              private formBuilder: FormBuilder){
    this.fg_hdr = this.formBuilder.group({});
  }

  ngOnInit(){
    this.plant = this.route.snapshot.paramMap.get('plant')
    this.plantDisplay = this.route.snapshot.paramMap.get('plantdisplay') ? this.route.snapshot.paramMap.get('plantdisplay') : this.plant;
    this.route.queryParams.subscribe(params => {
      this.severity=params['Severity'];
      this.line=params['Line'];
      this.lineDisplay = this.route.snapshot.paramMap.get('linedisplay') ? this.route.snapshot.paramMap.get('linedisplay') : this.line;
      this.fetch();
    });
    console.log ( ' Value of severeity ', this.severity )
    setTimeout(() => 
      { this.locationInformationService.changeLocation(true);
        this.locationInformationService.changePlant(this.plant);
        this.locationInformationService.changePlantView(true);
    
        if (typeof this.line !== "undefined"){
          this.locationInformationService.changeDetailsView(true);
          this.locationInformationService.changeDetailsInfo(this.line)
        } else{
          this.locationInformationService.changeDetailsView(false);
        }
        
    
        if (typeof this.severity !== "undefined"){
          this.locationInformationService.changeSeverityView(true);
          this.locationInformationService.changeSeverityInfo(this.severity)
        } else{
          this.locationInformationService.changeSeverityView(true);
          this.locationInformationService.changeSeverityInfo('All');
        }
        this.locationInformationService.severityInfo$.subscribe((severityInfo) => {
          this.severityInfo = severityInfo
        });
      })

    this.dataSource = new MatTableDataSource<SeverityType>();
    // FILTER LOGIC
    this.dataSource.filterPredicate = (data: SeverityType, filter: string) => {
      const f = JSON.parse(filter);
      return (
        (!f.model || data.Model?.toLowerCase().includes(f.model)) &&
        (!f.serial || data.Serial?.toLowerCase().includes(f.serial)) &&
        (!f.area || data.AreaDescription === f.area) &&
        (!f.component || data.ComponentDescription === f.component) &&
        (!f.defect || data.DefectDescription === f.defect) &&
        (!f.severity || data.Severity?.toLowerCase() === f.severity) &&
        (!f.shift || data.Shift === f.shift) && 
        (!f.line || data.Line?.toLowerCase().trim().includes(f.line.toLowerCase().trim()))
      );
    };

    this.isTablet$ = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  fetch(){
    this.loadingService.show();
    let d: Observable<GenericLambdaReturn<SeverityType[]>> =
      this.route.paramMap.pipe(
        switchMap((params:ParamMap) =>
        this.service.getDetailData(this.currentShift, this.fromDateString + ' 00:00:00', this.toDateString + ' 23:59:59.999', this.plant, this.line, this.severity,undefined, this.currentOffset))
      );
    
    
      if (this.subscription) this.subscription.unsubscribe();

    this.subscription = d.pipe(finalize(() => this.loadingService.hide())).subscribe((next) => {
      console.log(next.Body)
      this.dataSource.data=next.Body;
      this.hasMore = (next as any).HasMore;
      this.mDataSource = next.Body;
      
      this.severityDetailsArr = next.Body
      // build dropdown values
      this.buildFilterOptions();
      // apply filter after load
      this.filteredData = next.Body;
      this.applyFilter();
      this.dateString = this.fromDateString + '-' + this.toDateString
      this.isLoading = false;
      this.subscription.unsubscribe();
    })
  }

  nextPage() {
    this.currentOffset += this.pageSize;
    this.currentPage++;
    this.fetch();
  }

  prevPage() {
    if (this.currentOffset >= this.pageSize) {
      this.currentOffset -= this.pageSize;
      this.currentPage--;
    }
    this.fetch();
  }

  applyFilter() {
    const filter = {
      model: this.filterValues.model.toLowerCase(),
      serial: this.filterValues.serial.toLowerCase(),
      area: this.filterValues.area,
      component: this.filterValues.component,
      defect: this.filterValues.defect,
      severity: this.filterValues.severity.toLowerCase(), //  important
      shift: this.filterValues.shift
    };

    this.dataSource.filter = JSON.stringify(filter);
    this.filteredData = this.dataSource.filteredData;

    this.isFilterApplied = !!(filter.model || filter.serial || filter.area || filter.component || filter.defect || filter.severity || filter.shift);
  }

  resetFilters() {
    this.filterValues = {
      model: '',
      serial: '',
      area: '',
      component: '',
      defect: '',
      severity: '',
      shift: '',
      line: this.line || ''
    };

    // clear filter
    this.dataSource.filter = '';
    // reset filtered data
    this.filteredData = this.dataSource.data;
    this.isFilterApplied = false;
  }

  buildFilterOptions() {
    const sort = (arr: string[]) =>
      [...new Set(arr.filter(Boolean))].sort((a, b) =>
        a.localeCompare(b)
      );

    this.uniqueAreas = sort(this.mDataSource.map(x => x.AreaDescription));
    this.uniqueComponents = sort(this.mDataSource.map(x => x.ComponentDescription));
    this.uniqueDefects = sort(this.mDataSource.map(x => x.DefectDescription));
    this.uniqueShifts = sort(this.mDataSource.map(x => x.Shift));
  }

  displayAcknowledge(details: SeverityType){
    let AcknowledgeArray: AcknowledgeDetailType[] = [];
    let tabSize: number = 0;
    let strTabSize: string;

    AcknowledgeArray = [
      {
        "Comment": details.comment,
        "InsertDate": details.InsertDatetime,
        "UpdateDate": details.UpdateDatetime,
        "UserID": details.UserID

      }
    ]
   
    tabSize = 250 * 4;
    strTabSize = `${tabSize.toString()}px`

    const tableRef = this.AcknowledgeDialog.open(AcknowledgeTable, {
      width: strTabSize,
      data: 
      { 
        acknowledge: AcknowledgeArray,
        resultid: details.ResultId,
        site:details.site,
        acknowlegderesultid : details.Acknowledgeresultid
      }
    });
    tableRef.afterClosed().subscribe(() => { this.fetch(); } );
  }
  
  displayDetails(details: SeverityType){
    const tableRef = this.detailsDialog.open(DetailsTable, {
      data: 
      { 
        details: details
      }
    });
  }

  navToAnalysis(){
    this.router.navigate(['/analysis/'+this.plant], { queryParams: {Severity: this.severity, Line: this.line}})

  }

  navToShopFloor(){
    this.router.navigate(["/shopfloor", this.plant, this.line])
  }
  

  onDateChange(e: any) {
    this.fromDateString = e.fromDate;
    this.toDateString = e.toDate;
    this.currentShift = e.currentShift;
    this.currentOffset = 0;

    this.fetch();
   
  }

  loadAllRecords() {   
   if (this.isDownloading) {
      console.log("Already downloading, skipping...");
      return;
    }

    this.allRecords = [];
    this.currentDownloadOffset = 0;
    this.isDownloading = true;

    this.fetchAllRecords();
  }
  
  // Get all Records Data
  fetchAllRecords() {
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
    }
    
   this.loadingService.show();
   this.downloadSubscription = this.service.getAllDetailData(
      this.currentShift,
      this.fromDateString + ' 00:00:00',
      this.toDateString + ' 23:59:59.999',
      this.plant,
      this.line,
      this.severity,
      this.currentDownloadOffset
    ).pipe(finalize(() => this.loadingService.hide())).subscribe((next: SeverityLambdaReturn) => {

      const newData = next.Body || [];
      console.log(`Offset: ${this.currentDownloadOffset}, Fetched: ${newData.length}`);

      // empty data
      if (newData.length === 0) {
        console.log("No data returned, stopping...");
        this.isDownloading = false;
        return;
      }

      // Append    
      const existingIds = new Set(this.allRecords.map(x => x.ResultId));
      const uniqueData = newData.filter(x => !existingIds.has(x.ResultId));
      if (uniqueData.length === 0) {
        console.warn("Duplicate page detected → stopping");
        this.isDownloading = false;
          if (this.downloadSubscription) {
            this.downloadSubscription.unsubscribe();
          }
        return;
      }
      this.allRecords = [...this.allRecords, ...uniqueData];


      // last page (best condition)
      if (newData.length < this.pageSize) {
        console.log("Last page reached");
        this.isDownloading = false;
        if (this.downloadSubscription) {
          this.downloadSubscription.unsubscribe();
        }
        this.totalRecords = this.allRecords.length;
        this.saveDataToCsv();
        return;
      }

      // CONTINUE
      this.currentDownloadOffset += this.pageSize;

      // delay prevents retry storm
      setTimeout(() => this.fetchAllRecords(), 100);

    }, (error) => {
      console.error('Error while fetching:', error);
      this.isDownloading = false;
       if (this.downloadSubscription) {
          this.downloadSubscription.unsubscribe();
        }
    });
  }


  saveDataToCsv(){
    let data = this.isFilterApplied ? this.filteredData : this.allRecords;
    console.log(data)
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
     let csv = data.map(row =>  header.map(fieldName => {
        let value = row[fieldName];

        if (fieldName === 'ResultDateTime' && value) {
          value = String(value).replace('T', ' ');
          return `"\t${value}"`; 
        }

        return JSON.stringify(value ?? '', replacer);
      }).join(',')
    );
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    console.log(csvArray)
    let blob = new Blob([csvArray], {type: 'text/csv' })
    let fileName = this.dataSourceName + '_' + this.dateString + '.csv'
    saveAs(blob, fileName);
  }

}
